// Social sharings API
import { getAPI, token } from "@/api/params.js";

import { shareToInstagram } from "@/api/socials/instagram.js";
import { shareToFacebook } from "@/api/socials/facebook.js";
import { shareToYoutube } from "@/api/socials/youtube.js";
import { shareToTwitter } from "@/api/socials/twitter";

/**
 * Share video to different socials accounts
 * @param {Number} videoId Video ID
 * @param {Array} accounts Destinations data
 * @param
 */
export const shareVideo = async (videoId, dest, multistepId) => {
  const sharePromises = dest.map(
    shareVideoToSocial.bind(null, videoId, multistepId)
  );
  const shareResults = await Promise.allSettled(sharePromises);
  return shareResults;
};

async function shareVideoToSocial(videoId, multistepId, dest) {
  const { account, type, id, metadata } = dest;

  switch (account.social) {
    case "youtube":
      await shareToYoutube(videoId, account.id, metadata, multistepId);
      break;
    case "facebook":
      await shareToFacebook(videoId, account.id, id, type, metadata, multistepId);
      break;
    case "twitter":
      await shareToTwitter(videoId, account.id, metadata, multistepId);
      break;
    case "instagram":
      await shareToInstagram(
        videoId,
        account.id,
        account.metadata.facebookAccountId,
        account.metadata.facebookPageId,
        metadata,
        multistepId
      );
      break;
    default:
      throw new Error(`Unknown social ${account.social}`);
  }

  return {
    accountId: account.id,
    type: type,
    id: id,
    social: account.social
  };
}

/**
 * Remove sharing data (not video)
 * @param {Number} videoId Video ID
 * @param {Number} sharingId Shared video information ID
 */
export const removeSharing = async (videoId, sharingId) => {
  const removeURL = `${getAPI()}/video/${videoId}/share/${sharingId}?token=${token}`;
  const resp = await fetch(removeURL, { method: "DELETE" });
  const respObj = await resp.json();

  if (!respObj.success) {
    throw new Error(respObj.error);
  }
};
